import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { fmtEuro } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const Summary = ({ s }) => (
  <ul className="space-y-1 text-sm" data-testid="items-replace-summary">
    <li><b>{s.new_items}</b> articoli nuovi dal file</li>
    <li className="text-red-700"><b>{s.delete_items}</b> articoli attuali senza matricola verranno cancellati, con <b>{s.delete_stock_rows}</b> giacenze e <b>{s.delete_movements}</b> movimenti</li>
    <li><b>{s.kept_serialized}</b> apparati con matricola restano invariati</li>
  </ul>
);

const Sample = ({ rows }) => (
  <div className="max-h-56 overflow-auto border"><table className="w-full text-xs"><thead><tr className="bg-muted">{["Codice", "Descrizione", "U.M.", "Vendita"].map((h) => <th key={h} className="px-2 py-1 text-left">{h}</th>)}</tr></thead>
    <tbody>{rows.map((r) => <tr key={r.code} className="border-t"><td className="px-2 py-1 font-mono">{r.code}</td><td className="px-2 py-1">{r.name}</td><td className="px-2 py-1">{r.unit}</td><td className="px-2 py-1 font-mono">{fmtEuro(r.sale_price)}</td></tr>)}</tbody></table></div>
);

export const ItemsReplace = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [p, setP] = useState(null);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const form = (f) => { const fd = new FormData(); fd.append("file", f); return fd; };
  const pick = async (f) => {
    setFile(f); setP(null); setOk(false);
    if (!f) return;
    setBusy(true);
    try { setP((await api.post("/warehouse/items/replace/preview", form(f))).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const run = async () => {
    setBusy(true);
    try { const r = await api.post("/warehouse/items/replace", form(file)); toast.success(`Anagrafica sostituita: ${r.data.new_items} articoli caricati, ${r.data.delete_items} cancellati`); setOpen(false); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => { setOpen(true); setFile(null); setP(null); setOk(false); }} data-testid="items-replace-open"><FileSpreadsheet className="mr-2 h-4 w-4" />Sostituisci articoli da Excel</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader><DialogTitle className="font-display text-2xl">Sostituisci anagrafica articoli</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">File Excel con colonne: codice prodotto, descrizione articolo, unità di misura, prezzi vendita. Gli apparati con matricola non vengono toccati.</p>
          <input type="file" accept=".xlsx,.xlsm" onChange={(e) => pick(e.target.files[0])} data-testid="items-replace-file" />
          {p && <div className="space-y-3"><Summary s={p.summary} />
            {p.errors.length > 0 && <ul className="text-xs text-red-700" data-testid="items-replace-errors">{p.errors.map((e) => <li key={e}>{e}</li>)}</ul>}
            <Sample rows={p.sample} />
            <label className="flex items-start gap-2 text-sm"><Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} data-testid="items-replace-confirm-check" />Ho capito: gli articoli attuali senza matricola, le loro giacenze e i loro movimenti verranno cancellati definitivamente.</label>
          </div>}
          <DialogFooter><Button disabled={!p || !ok || busy || p.errors.length > 0} onClick={run} variant="destructive" data-testid="items-replace-run">Sostituisci articoli</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
